/*

The file where the Firebase authentication API will be defined to sign up,
sign in, sign out etc. a user in your application. It is the interface
between the official Firebase API and your React application.

*/

// import the instantiated auth object for the Firebase config file
import { auth } from './firebase'

// now
// define all the authentication functions below

// sign up
export const doCreateUserWithEmailAndPassword = (email, password) => {
	return auth.createUserWithEmailAndPassword(email, password)
}

// send email verification
export const doSendEmailVerification = () => {
	return auth.currentUser.sendEmailVerification()
}

// sign in
export const doSignInWithEmailAndPassword = (email, password) => {
	return auth.signInWithEmailAndPassword(email, password)
}

// sign out
export const doSignOut = () => {
	return auth.signOut()
}

// password reset
export const doPasswordReset = (email) => {
	return auth.sendPasswordResetEmail(email)
}

// password change
export const doPasswordUpdate = (password) => {
	return auth.currentUser.updatePassword(password)
}

// now
// expose the implemented authentication methods and the Firebase
// functionalities itself form your Firebase module (in index.js).


// WEBPACK FOOTER //
// ./src/common/firebase/auth.js